import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { TabletSvg } from './svg/tablet';

export const TabletIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TabletSvg} {...props} />
);
